export const YouMayAlsoLike = [
  {
    "id": '1000',
    "title": "Josera Nature Cat Dry Food Good for Cat",
    "brand": "Josera",
    "price": "AED 51.10",
    "originalPrice": "AED 70.00",
    "image": "https://petcornerdubai.com/uploads/cache/products/expiring-on-2705-josera-nature-cat-dry-food-2kg/17737339772093070531-230x220.jpg",
    "subimage": [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/17547408441010803229.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/1754740845541444861.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/17547422901936586973.jpg" }
    ]
  },
  {
    "id": "1001",
    "title": "Dentalight Natural Catnip 15g",
    "brand": "Dentalight",
    "price": "AED 80.00",
    "originalPrice": "AED 20.00",
    "image": "https://petcornerdubai.com/uploads/products/dentalight-natural-catnip-15g/17714892273349231.png",
    "subimage": [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/dentalight-natural-catnip-15g/17714892271247708375.png" },
    ]

  },
  {
    "id": '1002',
    "title": "Josera Kitten Cat Dry Food Good for Kitten",
    "brand": "Josera",
    "price": "AED 47.60",
    "originalPrice": "AED 70.00",
    "image": "https://petcornerdubai.com/uploads/cache/products/expiring-on-1306-josera-kitten-cat-dry-food-2kg/1773734070905639323-230x220.jpg",
    "subimage": [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/71R+n5jvYZL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/61Z0MiydjBL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/61aYcqFs9kL._AC_SL1200_.jpg" }
    ]
  },
  {
    "id": "1003",
    "title": "All for Paws Laser Mouse - Pink Cat Toy",
    "brand": "All for Paws",
    "price": "AED 26.19",
    "originalPrice": "AED 30.00",
    "image": "https://petcornerdubai.com/uploads/China%20Items/260118-172953.png",
    "subimage": [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/all-for-paws-laser-mouse-blue-cat-toy/1768742862473722672.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/all-for-paws-laser-mouse-blue-cat-toy/176874286267259825.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads/products/all-for-paws-laser-mouse-blue-cat-toy/1768742862452578.jpg" },
    ]
  },
  {
    "id": '1004',
    "title": "Josera Chicken with Duck Cat Wet Food",
    "brand": "Josera",
    "price": "AED 60.30",
    "originalPrice": "AED 70.00",
    "image": "https://petcornerdubai.com/uploads/cache/products/expiring-on-0706-josera-chicken-with-duck-cat-wet-/1773734028138604753-230x220.jpg",
    "subimage": [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/61OmhC3xkrL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/4032254750192-razem.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/cat-hero-desktop.jpg" }
    ]
  },
  {
    "id": "1005",
    "title": "Citrus Teaser Cat Toy",
    "brand": "Zee Dog",
    "price": "AED 55.00",
    "originalPrice": "AED 60.00",
    "image": "https://petcornerdubai.com/uploads/cache/products/zeecat-citrus-teaser-cat-toy/17629367151003523967-230x220.png",
    "subimage": [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763443945.webp" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763713953.webp" },
    ]
  },
  {
    "id": '4',
    "title": "Josera Duck & Chicken with Parsley",
    "brand": "Josera",
    "price": "AED 50.60",
    "originalPrice": "AED 70.00",
    "image": "https://petcornerdubai.com/uploads/cache/products/expiring-on-0606-josera-duck-chicken-with-parsley-/1773734018204937216-230x220.jpg",
    "subimage": [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/61tXmQ7IN7L._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/6154yrJeuzL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/61OmhC3xkrL._AC_SL1200_.jpg" }
    ]
  },
  {
    "id": "204",
    "title": "Tango Wand Cat Toy",
    "brand": "Zee Dog",
    "price": "AED 55.00",
    "originalPrice": "AED 60.00",
    "image": "https://petcornerdubai.com/uploads/cache/products/zeecat-tango-wand-cat-toy/17629367121376366149-230x220.png",
    "subimage": [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763444028.webp" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763713990.webp" },
    ]
  },
  {
    "id": '5',
    "title": "Josera Naturelle Cat Dry Food",
    "brand": "Josera",
    "price": "AED 51.10",
    "originalPrice": "AED 70.00",
    "image": "https://petcornerdubai.com/uploads/cache/products/expiring-on-0306-josera-naturelle-cat-dry-food-2kg/1773734006603373960-230x220.png",
    "subimage": [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/71+D0QwpliL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/71bhz3y-kuL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/maxresdefault-1.jpg" }
    ]
  },
  {
    "id": "205",
    "title": "Citrus Cat Scratcher",
    "brand": "Zee Dog",
    "price": "AED 95.00",
    "originalPrice": "AED 100.00",
    "image": "https://petcornerdubai.com/uploads/cache/products/zeecat-citrus-cat-scratcher/17629367001114161784-230x220.png",
    "subimage": [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763444322.webp" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763714127.webp" },
    ]
  },
]

export const fullProductStructure = [
  {
    sku: "Dog-Food-001",
    productname: "Josera Nature Cat Dry Food Good for Cat",
    brand: "Josera",
    saleprice: "AED 51.10",
    price: "AED 70.00",
    timer: "02:30:15",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-2705-josera-nature-cat-dry-food-2kg/17737339772093070531-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/17547408441010803229.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/1754740845541444861.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/17547422901936586973.jpg" }
    ],
    quantity: 20,
    status: true,
  },
  {
    sku: "Dog-Food-002",
    productname: "Josera Kitten Cat Dry Food Good for Kitten",
    brand: "Josera",
    saleprice: "AED 47.60",
    price: "AED 70.00",
    timer: "03:20:15",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-1306-josera-kitten-cat-dry-food-2kg/1773734070905639323-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/71R+n5jvYZL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/61Z0MiydjBL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/61aYcqFs9kL._AC_SL1200_.jpg" }
    ],
    quantity: 10,
    status: true,
  },
  {
    sku: "Dog-Food-003",
    productname: "Josera Chicken with Duck Cat Wet Food",
    brand: "Josera",
    saleprice: "AED 60.30",
    price: "AED 70.00",
    timer: "03:50:15",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-0706-josera-chicken-with-duck-cat-wet-/1773734028138604753-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/61OmhC3xkrL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/4032254750192-razem.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/cat-hero-desktop.jpg" }
    ],
    quantity: 30,
    status: true,
  },
  {
    sku: "Dog-Food-004",
    productname: "Josera Duck & Chicken with Parsley",
    brand: "Josera",
    saleprice: "AED 50.60",
    price: "AED 70.00",
    timer: "00:50:15",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-0606-josera-duck-chicken-with-parsley-/1773734018204937216-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/61tXmQ7IN7L._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/6154yrJeuzL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/61OmhC3xkrL._AC_SL1200_.jpg" }
    ],
    quantity: 40,
    status: true,
  },
  {
    sku: "Dog-Food-005",
    productname: "Josera Naturelle Cat Dry Food",
    brand: "Josera",
    saleprice: "AED 51.10",
    price: "AED 70.00",
    timer: "00:50:15",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-0306-josera-naturelle-cat-dry-food-2kg/1773734006603373960-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/71+D0QwpliL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/71bhz3y-kuL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/maxresdefault-1.jpg" }
    ],
    quantity: 24,
    status: true,
  },
  {
    sku: "Dog-Food-006",
    productname: "Josera Culinesse Cat Dry Food",
    brand: "Josera",
    saleprice: "AED 44.10",
    price: "AED 70.00",
    timer: "02:30:15",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-0306-josera-culinesse-cat-dry-food-2kg/177373400421182141-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/71veUmaRdFL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/61J1gFV9ZUL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/josera-kibble.jpg" }
    ],
    quantity: 29,
    status: true,
  },
  {
    sku: "Dog-Food-007",
    productname: "Josera Catelux Cat Dry Food",
    brand: "Josera",
    saleprice: "AED 48.30",
    price: "AED 70.00",
    timer: "02:30:15",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-3005-josera-catelux-cat-dry-food-2kg/17737339861454866989-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/61mqo8baMkL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/maxresdefault-3.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/71y9XvIDy8L._AC_SL1200_.jpg" }
    ],
    quantity: 11,
    status: true,
  },
  {
    sku: "Dog-Food-008",
    productname: "Josera Daily Cat Dry Food",
    brand: "Josera",
    saleprice: "AED 47.60",
    price: "AED 70.00",
    timer: "02:30:15",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-2805-josera-daily-cat-dry-food-2kg/1773733980104431821-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/josera-daily-cat-dry-food-2kg/1752155435465717186.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/josera-daily-cat-dry-food-2kg/175215543543051606.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads/products/josera-daily-cat-dry-food-2kg/17521554351295170110.jpg" }
    ],
    quantity: 9,
    status: true,
  },
  {
    sku: "Dog-Food-009",
    productname: "Josera Meat Lovers Pure Turkey Dog Wet Food",
    brand: "Josera",
    saleprice: "AED 47.60",
    price: "AED 70.00",
    timer: "02:30:15",
    productimage: "https://petcornerdubai.com/uploads/Josera/big_meatlovers-pureturkey.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/josera-meat-lovers-pure-turkey-dog-wet-food-400g/17521554351346823035.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/josera-meat-lovers-pure-turkey-dog-wet-food-400g/1752155435385549708.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads/products/josera-meat-lovers-pure-turkey-dog-wet-food-400g/1752155435104986603.jpg" }
    ],
    quantity: 17,
    status: true,
  },
  {
    sku: "Dog-Food-010",
    productname: "Josera Mini Deluxe Dog Dry Food",
    brand: "Josera",
    saleprice: "AED 51.10",
    price: "AED 70.00",
    timer: "02:30:15",
    productimage: "https://petcornerdubai.com/uploads/Josera/71kCcDTFODL._AC_SL1500_.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/josera-mini-deluxe-dog-dry-food-900g/17118003831771909876.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/61YlnRa7PhL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/61TKu-fNT9L._AC_SL1200_.jpg" }
    ],
    quantity: 21,
    status: true,
  },
]

export const JoseraFinal = [
  {
    productid: '1',
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    sku: "Dog-Food-001",
    productname: "Josera Nature Cat Dry Food Good for Cat",
    brand: "Josera",
    saleprice: "",
    price: "AED 70.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-2705-josera-nature-cat-dry-food-2kg/17737339772093070531-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/17547408441010803229.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/1754740845541444861.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/17547422901936586973.jpg" }
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/4106999/",
        thumbnail: "https://images.unsplash.com/photo-1695023267262-7f4ab64152b2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8ZG9nJTIwZWF0aW5nfGVufDB8fDB8fHww"
      },
    ],
    isSubscribe: true,
    description: "Give your cat the perfect balance of nutrition and taste with Josera Nature Cat Dry Food. Specially crafted with high-quality ingredients, this premium cat food supports healthy digestion, strong immunity, shiny coat health, and overall daily wellness. Its delicious flavor and crunchy texture make mealtime enjoyable while delivering essential vitamins, minerals, and protein your cat needs to stay active and healthy every day.",
    keyFeatures: [
      {
        id: "1",
        title: "Complete & balanced nutrition with essential vitamins and minerals"
      },
      {
        id: "2",
        title: "Supports healthy skin and a shiny coat with Omega 3 & 6 fatty acids"
      },
      {
        id: "3",
        title: "Easy-to-digest ingredients for better digestive health"
      },
      {
        id: "4",
        title: "Helps support strong immunity and daily vitality"
      }
    ]
  },
  {
    productid: '2',
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    sku: "Dog-Food-002",
    productname: "Josera Kitten Cat Dry Food Good for Kitten",
    brand: "Josera",
    saleprice: "AED 47.60",
    price: "AED 70.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-1306-josera-kitten-cat-dry-food-2kg/1773734070905639323-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/71R+n5jvYZL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/61Z0MiydjBL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/61aYcqFs9kL._AC_SL1200_.jpg" }
    ],
    quantity: 10,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://koreajoongangdaily.joins.com/data/photo/2021/06/02/8e59188b-c938-4750-b0ae-93325416c16c.gif",
        thumbnail: "https://images.unsplash.com/photo-1695023267262-7f4ab64152b2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8ZG9nJTIwZWF0aW5nfGVufDB8fDB8fHww"
      },
    ],
    isSubscribe: false,
    description: "Support your kitten’s healthy growth and development with Josera Kitten Cat Dry Food. Made with carefully selected high-quality ingredients, this nutritious kitten food provides essential proteins, vitamins, and minerals needed during the early growth stages. Its delicious taste and balanced recipe help support healthy digestion, strong immunity, brain development, and a healthy coat for active and happy kittens.",
    keyFeatures: [
      {
        id: "1",
        title: "Supports healthy growth and development for kittens"
      },
      {
        id: "2",
        title: "Rich in essential proteins, vitamins, and minerals"
      },
      {
        id: "3",
        title: "Helps support strong immunity and digestive health"
      },
      {
        id: "4",
        title: "Promotes healthy skin and a soft shiny coat"
      }
    ]
  },
  {
    productid: '3',
    sku: "Dog-Food-003",
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    productname: "Josera Chicken with Duck Cat Wet Food",
    brand: "Josera",
    saleprice: "",
    price: "AED 70.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-0706-josera-chicken-with-duck-cat-wet-/1773734028138604753-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/61OmhC3xkrL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/4032254750192-razem.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/cat-hero-desktop.jpg" }
    ],
    quantity: 30,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://koreajoongangdaily.joins.com/data/photo/2021/06/02/8e59188b-c938-4750-b0ae-93325416c16c.gif",
        thumbnail: "https://example.com/thumb.jpg"
      },
    ],
    isSubscribe: true,
    description: "Treat your cat to the rich and delicious taste of Josera Chicken with Duck Cat Wet Food. Prepared with high-quality chicken and duck, this premium wet food provides balanced nutrition and irresistible flavor for everyday feeding. Its soft texture and nutrient-rich recipe help support healthy digestion, hydration, strong muscles, and overall wellbeing for cats of all breeds.",
    keyFeatures: [
      {
        id: "1",
        title: "Made with high-quality chicken and duck for delicious taste"
      },
      {
        id: "2",
        title: "Soft wet food texture for easy eating and better hydration"
      },
      {
        id: "3",
        title: "Supports healthy digestion and daily nutrition"
      },
      {
        id: "4",
        title: "Helps maintain strong muscles and overall wellbeing"
      }
    ]
  },
  {
    productid: '4',
    sku: "Dog-Food-004",
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    productname: "Josera Duck & Chicken with Parsley",
    brand: "Josera",
    saleprice: "AED 50.60",
    price: "AED 70.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-0606-josera-duck-chicken-with-parsley-/1773734018204937216-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/61tXmQ7IN7L._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/6154yrJeuzL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/61OmhC3xkrL._AC_SL1200_.jpg" }
    ],
    quantity: 40,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://koreajoongangdaily.joins.com/data/photo/2021/06/02/8e59188b-c938-4750-b0ae-93325416c16c.gif",
        thumbnail: "https://example.com/thumb.jpg"
      },
    ],
    isSubscribe: false,
    description: "Give your cat a flavorful and nutritious meal with Josera Duck & Chicken with Parsley Wet Food. Made with premium duck and chicken ingredients blended with parsley, this delicious recipe provides balanced nutrition and irresistible taste for daily feeding. Its soft texture and nutrient-rich formula help support healthy digestion, hydration, muscle health, and overall vitality for happy and active cats.",
    keyFeatures: [
      {
        id: "1",
        title: "Made with premium duck and chicken for rich flavor"
      },
      {
        id: "2",
        title: "Contains parsley for added freshness and nutrition"
      },
      {
        id: "3",
        title: "Supports healthy digestion and hydration"
      },
      {
        id: "4",
        title: "Helps maintain muscle health and overall vitality"
      }
    ]
  },
  {
    productid: '5',
    sku: "Dog-Food-005",
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    productname: "Josera Naturelle Cat Dry Food",
    brand: "Josera",
    saleprice: "",
    price: "AED 70.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-0306-josera-naturelle-cat-dry-food-2kg/1773734006603373960-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/71+D0QwpliL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/71bhz3y-kuL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/maxresdefault-1.jpg" }
    ],
    quantity: 24,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://koreajoongangdaily.joins.com/data/photo/2021/06/02/8e59188b-c938-4750-b0ae-93325416c16c.gif",
        thumbnail: "https://images.unsplash.com/photo-1695023267262-7f4ab64152b2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8ZG9nJTIwZWF0aW5nfGVufDB8fDB8fHww"
      },
    ],
    isSubscribe: true,
    description: "Provide your cat with wholesome everyday nutrition through Josera Naturelle Cat Dry Food. Carefully prepared with high-quality ingredients, this balanced dry food supports healthy digestion, strong immunity, and overall wellness for adult cats. Its crunchy texture and delicious taste make every meal enjoyable while helping maintain healthy skin, a shiny coat, and active energy levels.",
    keyFeatures: [
      {
        id: "1",
        title: "Made with high-quality ingredients for balanced daily nutrition"
      },
      {
        id: "2",
        title: "Supports healthy digestion and overall wellbeing"
      },
      {
        id: "3",
        title: "Helps maintain healthy skin and a shiny coat"
      },
      {
        id: "4",
        title: "Provides essential nutrients for active and healthy cats"
      }
    ]
  },
  {
    productid: '6',
    sku: "Dog-Food-006",
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    productname: "Josera Culinesse Cat Dry Food",
    brand: "Josera",
    saleprice: "AED 44.10",
    price: "AED 70.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-0306-josera-culinesse-cat-dry-food-2kg/177373400421182141-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/71veUmaRdFL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/61J1gFV9ZUL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/josera-kibble.jpg" }
    ],
    quantity: 29,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://koreajoongangdaily.joins.com/data/photo/2021/06/02/8e59188b-c938-4750-b0ae-93325416c16c.gif",
        thumbnail: "https://example.com/thumb.jpg"
      },
    ],
    isSubscribe: false,
    description: "Delight your cat with the tasty and nutritious goodness of Josera Culinesse Cat Dry Food. Made with carefully selected ingredients and high-quality protein, this premium dry food supports healthy digestion, strong immunity, and balanced daily nutrition. Its crunchy texture and flavorful recipe help maintain healthy skin, a shiny coat, and active energy levels for adult cats.",
    keyFeatures: [
      {
        id: "1",
        title: "Made with high-quality protein for balanced daily nutrition"
      },
      {
        id: "2",
        title: "Supports healthy digestion and immune system health"
      },
      {
        id: "3",
        title: "Helps maintain healthy skin and a shiny coat"
      },
      {
        id: "4",
        title: "Crunchy texture and delicious taste cats enjoy"
      }
    ]
  },
  {
    productid: '7',
    sku: "Dog-Food-007",
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    productname: "Josera Catelux Cat Dry Food",
    brand: "Josera",
    saleprice: "",
    price: "AED 70.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-3005-josera-catelux-cat-dry-food-2kg/17737339861454866989-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/61mqo8baMkL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/maxresdefault-3.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/71y9XvIDy8L._AC_SL1200_.jpg" }
    ],
    quantity: 11,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://koreajoongangdaily.joins.com/data/photo/2021/06/02/8e59188b-c938-4750-b0ae-93325416c16c.gif",
        thumbnail: "https://example.com/thumb.jpg"
      },
    ],
    isSubscribe: true,
  },
  {
    productid: '8',
    sku: "Dog-Food-008",
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    productname: "Josera Daily Cat Dry Food",
    brand: "Josera",
    saleprice: "AED 47.60",
    price: "AED 70.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-2805-josera-daily-cat-dry-food-2kg/1773733980104431821-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/josera-daily-cat-dry-food-2kg/1752155435465717186.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/josera-daily-cat-dry-food-2kg/175215543543051606.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads/products/josera-daily-cat-dry-food-2kg/17521554351295170110.jpg" }
    ],
    quantity: 9,
    productstatus: true,
    video: [
      { id: '1', image: "https://koreajoongangdaily.joins.com/data/photo/2021/06/02/8e59188b-c938-4750-b0ae-93325416c16c.gif" },
    ],
    isSubscribe: false,
  },
  {
    productid: '9',
    sku: "Dog-Food-009",
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    productname: "Josera Meat Lovers Pure Turkey Dog Wet Food",
    brand: "Josera",
    saleprice: "",
    price: "AED 70.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/Josera/big_meatlovers-pureturkey.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/josera-meat-lovers-pure-turkey-dog-wet-food-400g/17521554351346823035.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/josera-meat-lovers-pure-turkey-dog-wet-food-400g/1752155435385549708.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads/products/josera-meat-lovers-pure-turkey-dog-wet-food-400g/1752155435104986603.jpg" }
    ],
    quantity: 17,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://koreajoongangdaily.joins.com/data/photo/2021/06/02/8e59188b-c938-4750-b0ae-93325416c16c.gif",
        thumbnail: "https://example.com/thumb.jpg"
      },
    ],
    isSubscribe: true,
  },
  {
    productid: '10',
    sku: "Dog-Food-010",
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    productname: "Josera Mini Deluxe Dog Dry Food",
    brand: "Josera",
    saleprice: "AED 51.10",
    price: "AED 70.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/Josera/71kCcDTFODL._AC_SL1500_.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/josera-mini-deluxe-dog-dry-food-900g/17118003831771909876.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/61YlnRa7PhL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/61TKu-fNT9L._AC_SL1200_.jpg" }
    ],
    quantity: 21,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://koreajoongangdaily.joins.com/data/photo/2021/06/02/8e59188b-c938-4750-b0ae-93325416c16c.gif",
        thumbnail: "https://example.com/thumb.jpg"
      },
    ],
    isSubscribe: false,
  },
]

export const CatToysFinal = [
  {
    productid: '1',
    sku: "Cat-Toy-001",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "Dentalight Natural Catnip 15g",
    brand: "Dentalight",
    saleprice: "",
    price: "AED 20.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/dentalight-natural-catnip-15g/17714892273349231-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/dentalight-natural-catnip-15g/17714892271247708375.png" },
      { id: '2', image: "https://images.unsplash.com/photo-1768042230927-a3dbc38bbc86?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D" },
      { id: '3', image: "https://plus.unsplash.com/premium_photo-1664371206097-882cd0782f43?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGNhdCUyMHBsYXlpbmclMjB3aXRoJTIwdG95fGVufDB8fDB8fHww" }
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: true,
    description: "Make playtime more exciting for your cat with Dentalight Natural Catnip 15g. Made from natural premium-quality catnip, this playful treat helps stimulate your cat’s senses, encourage active play, and reduce boredom. Its irresistible aroma keeps cats entertained while supporting relaxation and healthy activity for indoor and outdoor cats.",
    keyFeatures: [
      {
        id: "1",
        title: "Made with natural premium-quality catnip"
      },
      {
        id: "2",
        title: "Encourages playful and active behavior in cats"
      },
      {
        id: "3",
        title: "Helps reduce boredom and stress"
      },
      {
        id: "4",
        title: "Irresistible aroma cats naturally enjoy"
      }
    ]
  },
  {
    productid: '2',
    sku: "Cat-Toy-002",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "All for Paws Laser Mouse - Pink Cat Toy",
    brand: "All for Paws",
    saleprice: "AED 26.19",
    price: "AED 30.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/China%20Items/260118-172953.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/all-for-paws-laser-mouse-blue-cat-toy/1768742862473722672.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/all-for-paws-laser-mouse-blue-cat-toy/176874286267259825.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads/products/all-for-paws-laser-mouse-blue-cat-toy/1768742862452578.jpg" },
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: false,
    description: "Keep your cat active and entertained with the All for Paws Laser Mouse Pink Cat Toy. Designed to stimulate your cat’s natural hunting instincts, this interactive toy encourages exercise, playful movement, and mental engagement. Its lightweight and easy-to-use design makes playtime fun while helping reduce boredom and support healthy activity indoors.",
    keyFeatures: [
      {
        id: "1",
        title: "Interactive laser toy that encourages active play"
      },
      {
        id: "2",
        title: "Stimulates natural hunting and chasing instincts"
      },
      {
        id: "3",
        title: "Helps reduce boredom and indoor inactivity"
      },
      {
        id: "4",
        title: "Lightweight and easy-to-use playful design"
      }
    ]
  },
  {
    productid: '3',
    sku: "Cat-Toy-003",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "Citrus Teaser Cat Toy",
    brand: "Zee Dog",
    saleprice: "",
    price: "AED 60.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/zeecat-citrus-teaser-cat-toy/17629367151003523967-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763443945.webp" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763713953.webp" },
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: true,
    description: "Make playtime exciting and engaging with the Citrus Teaser Cat Toy by Zee Dog. Designed to encourage your cat’s natural hunting and chasing instincts, this interactive teaser toy keeps cats mentally stimulated and physically active. Its fun design and playful movement help reduce boredom while creating enjoyable bonding moments between pets and owners.",
    keyFeatures: [
      {
        id: "1",
        title: "Interactive teaser toy for active and playful cats"
      },
      {
        id: "2",
        title: "Encourages natural hunting and chasing instincts"
      },
      {
        id: "3",
        title: "Helps reduce boredom and supports daily exercise"
      },
      {
        id: "4",
        title: "Fun and engaging design for interactive playtime"
      }
    ]
  },
  {
    productid: '4',
    sku: "Cat-Toy-004",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "Tango Wand Cat Toy",
    brand: "Zee Dog",
    saleprice: "AED 55.00",
    price: "AED 60.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/zeecat-tango-wand-cat-toy/17629367121376366149-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763444028.webp" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763713990.webp" },
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: false,
    description: "Keep your cat entertained and active with the Tango Wand Cat Toy by Zee Dog. This interactive wand toy is designed to stimulate your cat’s natural hunting instincts through fun chasing, jumping, and playful movements. Its engaging design helps encourage exercise, mental stimulation, and bonding time between cats and their owners.",
    keyFeatures: [
      {
        id: "1",
        title: "Interactive wand toy for exciting play sessions"
      },
      {
        id: "2",
        title: "Encourages natural hunting and chasing behavior"
      },
      {
        id: "3",
        title: "Supports daily exercise and mental stimulation"
      },
      {
        id: "4",
        title: "Helps create fun bonding moments with your cat"
      }
    ]
  },
  {
    productid: '5',
    sku: "Cat-Toy-005",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "Citrus Cat Scratcher",
    brand: "Zee Dog",
    saleprice: "",
    price: "AED 100.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/zeecat-citrus-cat-scratcher/17629367001114161784-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763444322.webp" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763714127.webp" },
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: true,
    description: "Give your cat a fun and comfortable place to scratch with the Citrus Cat Scratcher by Zee Dog. Designed to support your cat’s natural scratching instincts, this scratcher helps keep claws healthy while protecting furniture from damage. Its playful citrus-inspired design adds entertainment and relaxation, making it perfect for active indoor cats.",
    keyFeatures: [
      {
        id: "1",
        title: "Supports natural scratching behavior in cats"
      },
      {
        id: "2",
        title: "Helps maintain healthy claws and nail care"
      },
      {
        id: "3",
        title: "Reduces furniture scratching and boredom"
      },
      {
        id: "4",
        title: "Fun citrus-inspired design for indoor play and relaxation"
      }
    ]
  },
  {
    productid: '6',
    sku: "Cat-Toy-006",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "M-Pets Herball Catnip Ball Green Cat Toy",
    brand: "M-Pets",
    saleprice: "AED 10.95",
    price: "AED 15.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/m-pets-herball-catnip-ball-green-cat-toy/17625084191109368291-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/m-pets-herball-catnip-ball-green-cat-toy/17625084211998062813.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/m-pets-herball-catnip-ball-green-cat-toy/17625084221705219288.jpg" },
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: false,
  },
  {
    productid: '7',
    sku: "Cat-Toy-007",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "Royal Canin Kitten - Welcome Home Kitten Box",
    brand: "Pet Corner Packages",
    saleprice: "",
    price: "AED 355.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/Bundle%20deals/New-Kitten-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Bundle%20deals/250921-192653.png" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Bundle%20deals/250921-193115.png" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Bundle%20deals/250921-192939.png" },
      { id: '24', image: "https://petcornerdubai.com/uploads//Bundle%20deals/250921-192858.png" },
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: true,
  },
  {
    productid: '8',
    sku: "Cat-Toy-008",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "VETRESKA Heartpurrple Cat Climber（Four Platforms)",
    brand: "Vetreska",
    saleprice: "AED 513.76",
    price: "AED 520.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/vetreska-heartpurrple-cat-climberfour-platforms/17569667291015979556-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/vetreska-heartpurrple-cat-climberfour-platforms/17569667301679125330.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/vetreska-heartpurrple-cat-climberfour-platforms/1756966731885453434.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads/products/vetreska-heartpurrple-cat-climberfour-platforms/17569667321150334328.jpg" },
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: false,
  },
  {
    productid: '9',
    sku: "Cat-Toy-009",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "VETRESKA Strawberry Cat Scratching Ball",
    brand: "Vetreska",
    saleprice: "",
    price: "AED 240.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/vetreska-strawberry-cat-scratching-ball/1756966713129164582-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/vetreska-strawberry-cat-scratching-ball/17569667141776368436.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/vetreska-strawberry-cat-scratching-ball/17569667151412478781.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads/products/vetreska-strawberry-cat-scratching-ball/17569667162137079457.jpg" },
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: true,
  },
  {
    productid: '10',
    sku: "Cat-Toy-010",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "Pet Safe Bolt Automatic Laser Light Interactive Cat Laser",
    brand: "Petsafe",
    saleprice: "AED 220.16",
    price: "AED 240.00",
    startDate: "21-05-2026",
    endDate: "31-05-2026",
    productimage: "https://petcornerdubai.com/uploads/cache/products/pet-safe-bolt-automatic-laser-light-interactive-ca/1754395411388971198-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/pet-safe-bolt-automatic-laser-light-interactive-ca/17543954121742564142.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/pet-safe-bolt-automatic-laser-light-interactive-ca/17543954121863236319.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads/products/pet-safe-bolt-automatic-laser-light-interactive-ca/17543954121898531332.jpg" },
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: false,
  },
]

export const WithoutOffersFinal = [
  {
    productid: '101',
    sku: "Dog-Food-001",
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    productname: "Josera Nature Cat Dry Food Good for Cat",
    brand: "Josera",
    saleprice: "",
    price: "AED 70.00",
    startDate: "",
    endDate: "",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-2705-josera-nature-cat-dry-food-2kg/17737339772093070531-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/17547408441010803229.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/1754740845541444861.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads/products/josera-nature-cat-dry-food-400g/17547422901936586973.jpg" }
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/4106999/",
        thumbnail: "https://images.unsplash.com/photo-1695023267262-7f4ab64152b2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8ZG9nJTIwZWF0aW5nfGVufDB8fDB8fHww"
      },
    ],
    isSubscribe: true,
    description: "Give your cat the perfect balance of nutrition and taste with Josera Nature Cat Dry Food. Specially crafted with high-quality ingredients, this premium cat food supports healthy digestion, strong immunity, shiny coat health, and overall daily wellness. Its delicious flavor and crunchy texture make mealtime enjoyable while delivering essential vitamins, minerals, and protein your cat needs to stay active and healthy every day.",
    keyFeatures: [
      {
        id: "1",
        title: "Complete & balanced nutrition with essential vitamins and minerals"
      },
      {
        id: "2",
        title: "Supports healthy skin and a shiny coat with Omega 3 & 6 fatty acids"
      },
      {
        id: "3",
        title: "Easy-to-digest ingredients for better digestive health"
      },
      {
        id: "4",
        title: "Helps support strong immunity and daily vitality"
      }
    ]
  },
  {
    productid: '102',
    sku: "Dog-Food-002",
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    productname: "Josera Kitten Cat Dry Food Good for Kitten",
    brand: "Josera",
    saleprice: "",
    price: "AED 70.00",
    startDate: "",
    endDate: "",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-1306-josera-kitten-cat-dry-food-2kg/1773734070905639323-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/71R+n5jvYZL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/61Z0MiydjBL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/61aYcqFs9kL._AC_SL1200_.jpg" }
    ],
    quantity: 10,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://koreajoongangdaily.joins.com/data/photo/2021/06/02/8e59188b-c938-4750-b0ae-93325416c16c.gif",
        thumbnail: "https://images.unsplash.com/photo-1695023267262-7f4ab64152b2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8ZG9nJTIwZWF0aW5nfGVufDB8fDB8fHww"
      },
    ],
    isSubscribe: true,
    description: "Support your kitten’s healthy growth and development with Josera Kitten Cat Dry Food. Made with carefully selected high-quality ingredients, this nutritious kitten food provides essential proteins, vitamins, and minerals needed during the early growth stages. Its delicious taste and balanced recipe help support healthy digestion, strong immunity, brain development, and a healthy coat for active and happy kittens.",
    keyFeatures: [
      {
        id: "1",
        title: "Supports healthy growth and development for kittens"
      },
      {
        id: "2",
        title: "Rich in essential proteins, vitamins, and minerals"
      },
      {
        id: "3",
        title: "Helps support strong immunity and digestive health"
      },
      {
        id: "4",
        title: "Promotes healthy skin and a soft shiny coat"
      }
    ]
  },
  {
    productid: '103',
    sku: "Dog-Food-003",
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    productname: "Josera Chicken with Duck Cat Wet Food",
    brand: "Josera",
    saleprice: "",
    price: "AED 70.00",
    startDate: "",
    endDate: "",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-0706-josera-chicken-with-duck-cat-wet-/1773734028138604753-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/61OmhC3xkrL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/4032254750192-razem.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/cat-hero-desktop.jpg" }
    ],
    quantity: 30,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://koreajoongangdaily.joins.com/data/photo/2021/06/02/8e59188b-c938-4750-b0ae-93325416c16c.gif",
        thumbnail: "https://example.com/thumb.jpg"
      },
    ],
    isSubscribe: true,
    description: "Treat your cat to the rich and delicious taste of Josera Chicken with Duck Cat Wet Food. Prepared with high-quality chicken and duck, this premium wet food provides balanced nutrition and irresistible flavor for everyday feeding. Its soft texture and nutrient-rich recipe help support healthy digestion, hydration, strong muscles, and overall wellbeing for cats of all breeds.",
    keyFeatures: [
      {
        id: "1",
        title: "Made with high-quality chicken and duck for delicious taste"
      },
      {
        id: "2",
        title: "Soft wet food texture for easy eating and better hydration"
      },
      {
        id: "3",
        title: "Supports healthy digestion and daily nutrition"
      },
      {
        id: "4",
        title: "Helps maintain strong muscles and overall wellbeing"
      }
    ]
  },
  {
    productid: '104',
    sku: "Dog-Food-004",
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    productname: "Josera Duck & Chicken with Parsley",
    brand: "Josera",
    saleprice: "",
    price: "AED 70.00",
    startDate: "",
    endDate: "",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-0606-josera-duck-chicken-with-parsley-/1773734018204937216-230x220.jpg",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/61tXmQ7IN7L._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/6154yrJeuzL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/61OmhC3xkrL._AC_SL1200_.jpg" }
    ],
    quantity: 40,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://koreajoongangdaily.joins.com/data/photo/2021/06/02/8e59188b-c938-4750-b0ae-93325416c16c.gif",
        thumbnail: "https://example.com/thumb.jpg"
      },
    ],
    isSubscribe: true,
    description: "Give your cat a flavorful and nutritious meal with Josera Duck & Chicken with Parsley Wet Food. Made with premium duck and chicken ingredients blended with parsley, this delicious recipe provides balanced nutrition and irresistible taste for daily feeding. Its soft texture and nutrient-rich formula help support healthy digestion, hydration, muscle health, and overall vitality for happy and active cats.",
    keyFeatures: [
      {
        id: "1",
        title: "Made with premium duck and chicken for rich flavor"
      },
      {
        id: "2",
        title: "Contains parsley for added freshness and nutrition"
      },
      {
        id: "3",
        title: "Supports healthy digestion and hydration"
      },
      {
        id: "4",
        title: "Helps maintain muscle health and overall vitality"
      }
    ]
  },
  {
    productid: '105',
    sku: "Dog-Food-005",
    category: 'Dog',
    subcategory: 'Food',
    innerCategory: 'Dry Food',
    productname: "Josera Naturelle Cat Dry Food",
    brand: "Josera",
    saleprice: "",
    price: "AED 70.00",
    startDate: "",
    endDate: "",
    productimage: "https://petcornerdubai.com/uploads/cache/products/expiring-on-0306-josera-naturelle-cat-dry-food-2kg/1773734006603373960-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads//Josera/71+D0QwpliL._AC_SL1200_.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads//Josera/71bhz3y-kuL._AC_SL1200_.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads//Josera/maxresdefault-1.jpg" }
    ],
    quantity: 24,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://koreajoongangdaily.joins.com/data/photo/2021/06/02/8e59188b-c938-4750-b0ae-93325416c16c.gif",
        thumbnail: "https://images.unsplash.com/photo-1695023267262-7f4ab64152b2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8ZG9nJTIwZWF0aW5nfGVufDB8fDB8fHww"
      },
    ],
    isSubscribe: true,
    description: "Provide your cat with wholesome everyday nutrition through Josera Naturelle Cat Dry Food. Carefully prepared with high-quality ingredients, this balanced dry food supports healthy digestion, strong immunity, and overall wellness for adult cats. Its crunchy texture and delicious taste make every meal enjoyable while helping maintain healthy skin, a shiny coat, and active energy levels.",
    keyFeatures: [
      {
        id: "1",
        title: "Made with high-quality ingredients for balanced daily nutrition"
      },
      {
        id: "2",
        title: "Supports healthy digestion and overall wellbeing"
      },
      {
        id: "3",
        title: "Helps maintain healthy skin and a shiny coat"
      },
      {
        id: "4",
        title: "Provides essential nutrients for active and healthy cats"
      }
    ]
  },
  {
    productid: '106',
    sku: "Cat-Toy-001",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "Dentalight Natural Catnip 15g",
    brand: "Dentalight",
    saleprice: "",
    price: "AED 20.00",
    startDate: "",
    endDate: "",
    productimage: "https://petcornerdubai.com/uploads/cache/products/dentalight-natural-catnip-15g/17714892273349231-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/dentalight-natural-catnip-15g/17714892271247708375.png" },
      { id: '2', image: "https://images.unsplash.com/photo-1768042230927-a3dbc38bbc86?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D" },
      { id: '3', image: "https://plus.unsplash.com/premium_photo-1664371206097-882cd0782f43?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGNhdCUyMHBsYXlpbmclMjB3aXRoJTIwdG95fGVufDB8fDB8fHww" }
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: true,
    description: "Make playtime more exciting for your cat with Dentalight Natural Catnip 15g. Made from natural premium-quality catnip, this playful treat helps stimulate your cat’s senses, encourage active play, and reduce boredom. Its irresistible aroma keeps cats entertained while supporting relaxation and healthy activity for indoor and outdoor cats.",
    keyFeatures: [
      {
        id: "1",
        title: "Made with natural premium-quality catnip"
      },
      {
        id: "2",
        title: "Encourages playful and active behavior in cats"
      },
      {
        id: "3",
        title: "Helps reduce boredom and stress"
      },
      {
        id: "4",
        title: "Irresistible aroma cats naturally enjoy"
      }
    ]
  },
  {
    productid: '107',
    sku: "Cat-Toy-002",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "All for Paws Laser Mouse - Pink Cat Toy",
    brand: "All for Paws",
    saleprice: "",
    price: "AED 30.00",
    startDate: "",
    endDate: "",
    productimage: "https://petcornerdubai.com/uploads/China%20Items/260118-172953.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/all-for-paws-laser-mouse-blue-cat-toy/1768742862473722672.jpg" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/all-for-paws-laser-mouse-blue-cat-toy/176874286267259825.jpg" },
      { id: '3', image: "https://petcornerdubai.com/uploads/products/all-for-paws-laser-mouse-blue-cat-toy/1768742862452578.jpg" },
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: true,
    description: "Keep your cat active and entertained with the All for Paws Laser Mouse Pink Cat Toy. Designed to stimulate your cat’s natural hunting instincts, this interactive toy encourages exercise, playful movement, and mental engagement. Its lightweight and easy-to-use design makes playtime fun while helping reduce boredom and support healthy activity indoors.",
    keyFeatures: [
      {
        id: "1",
        title: "Interactive laser toy that encourages active play"
      },
      {
        id: "2",
        title: "Stimulates natural hunting and chasing instincts"
      },
      {
        id: "3",
        title: "Helps reduce boredom and indoor inactivity"
      },
      {
        id: "4",
        title: "Lightweight and easy-to-use playful design"
      }
    ]
  },
  {
    productid: '108',
    sku: "Cat-Toy-003",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "Citrus Teaser Cat Toy",
    brand: "Zee Dog",
    saleprice: "",
    price: "AED 60.00",
    startDate: "",
    endDate: "",
    productimage: "https://petcornerdubai.com/uploads/cache/products/zeecat-citrus-teaser-cat-toy/17629367151003523967-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763443945.webp" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763713953.webp" },
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: true,
    description: "Make playtime exciting and engaging with the Citrus Teaser Cat Toy by Zee Dog. Designed to encourage your cat’s natural hunting and chasing instincts, this interactive teaser toy keeps cats mentally stimulated and physically active. Its fun design and playful movement help reduce boredom while creating enjoyable bonding moments between pets and owners.",
    keyFeatures: [
      {
        id: "1",
        title: "Interactive teaser toy for active and playful cats"
      },
      {
        id: "2",
        title: "Encourages natural hunting and chasing instincts"
      },
      {
        id: "3",
        title: "Helps reduce boredom and supports daily exercise"
      },
      {
        id: "4",
        title: "Fun and engaging design for interactive playtime"
      }
    ]
  },
  {
    productid: '109',
    sku: "Cat-Toy-004",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "Tango Wand Cat Toy",
    brand: "Zee Dog",
    saleprice: "",
    price: "AED 60.00",
    startDate: "",
    endDate: "",
    productimage: "https://petcornerdubai.com/uploads/cache/products/zeecat-tango-wand-cat-toy/17629367121376366149-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763444028.webp" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763713990.webp" },
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: true,
    description: "Keep your cat entertained and active with the Tango Wand Cat Toy by Zee Dog. This interactive wand toy is designed to stimulate your cat’s natural hunting instincts through fun chasing, jumping, and playful movements. Its engaging design helps encourage exercise, mental stimulation, and bonding time between cats and their owners.",
    keyFeatures: [
      {
        id: "1",
        title: "Interactive wand toy for exciting play sessions"
      },
      {
        id: "2",
        title: "Encourages natural hunting and chasing behavior"
      },
      {
        id: "3",
        title: "Supports daily exercise and mental stimulation"
      },
      {
        id: "4",
        title: "Helps create fun bonding moments with your cat"
      }
    ]
  },
  {
    productid: '110',
    sku: "Cat-Toy-005",
    category: 'Cat',
    subcategory: 'Toy',
    innerCategory: 'Cat Toy',
    productname: "Citrus Cat Scratcher",
    brand: "Zee Dog",
    saleprice: "",
    price: "AED 100.00",
    startDate: "",
    endDate: "",
    productimage: "https://petcornerdubai.com/uploads/cache/products/zeecat-citrus-cat-scratcher/17629367001114161784-230x220.png",
    subimage: [
      { id: '1', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763444322.webp" },
      { id: '2', image: "https://petcornerdubai.com/uploads/products/kim-carlos-idamla/1763714127.webp" },
    ],
    quantity: 20,
    productstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/6864989/",
        thumbnail: "https://images.unsplash.com/photo-1775483680617-6dde248dad4c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2F0JTIwcGxheWluZyUyMHdpdGglMjB0b3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    isSubscribe: true,
    description: "Give your cat a fun and comfortable place to scratch with the Citrus Cat Scratcher by Zee Dog. Designed to support your cat’s natural scratching instincts, this scratcher helps keep claws healthy while protecting furniture from damage. Its playful citrus-inspired design adds entertainment and relaxation, making it perfect for active indoor cats.",
    keyFeatures: [
      {
        id: "1",
        title: "Supports natural scratching behavior in cats"
      },
      {
        id: "2",
        title: "Helps maintain healthy claws and nail care"
      },
      {
        id: "3",
        title: "Reduces furniture scratching and boredom"
      },
      {
        id: "4",
        title: "Fun citrus-inspired design for indoor play and relaxation"
      }
    ]
  },
]

export const DogBreeds = [
  {
    petid: '1',
    category: 'Dog',
    microchipid: "Dog-001",
    petname: "Coco",
    breed: "Golden Retriever",
    price: "AED 1000.00",
    productimage: "https://images.unsplash.com/photo-1591160690555-5debfba289f0?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Z29sZGVuJTIwcmV0cmlldmVyJTIwcHVwcHl8ZW58MHx8MHx8fDA%3D",
    subimage: [
      { id: '1', image: "https://plus.unsplash.com/premium_photo-1694819488591-a43907d1c5cc?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Z29sZGVuJTIwcmV0cmlldmVyJTIwcHVwcHl8ZW58MHx8MHx8fDA%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1625794084867-8ddd239946b1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGdvbGRlbiUyMHJldHJpZXZlciUyMHB1cHB5fGVufDB8fDB8fHww" },
      { id: '3', image: "https://images.unsplash.com/photo-1600804340584-c7db2eacf0bf?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGdvbGRlbiUyMHJldHJpZXZlciUyMHB1cHB5fGVufDB8fDB8fHww" }
    ],
    petstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/29477854/",
        thumbnail: "https://images.unsplash.com/photo-1510771463146-e89e6e86560e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGdvbGRlbiUyMHJldHJpZXZlcnxlbnwwfHwwfHx8MA%3D%3D"
      },
    ],
    description: "Healthy and playful Golden Retriever puppy available for sale. Raised in a loving environment with proper vaccination and nutrition. Friendly temperament, highly intelligent, and perfect for families and children.",
    age: '2 months',
    gender: 'Male',
    bookprice: 'AED 200',
    saleprice: 'AED 700'
  },
  {
    petid: '2',
    category: 'Dog',
    microchipid: "Dog-002",
    petname: "Milo",
    breed: "Siberian Husky",
    price: "AED 900.00",
    productimage: "https://images.unsplash.com/photo-1617895153857-82fe79adfcd4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aHVza3klMjBwdXBweXxlbnwwfHwwfHx8MA%3D%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1566903451935-7e8835ed3e97?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8aHVza3klMjBwdXBweXxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1543554618-7e19c5e393d9?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fGh1c2t5JTIwcHVwcHl8ZW58MHx8MHx8fDA%3D" },
      { id: '3', image: "https://images.unsplash.com/photo-1523286435788-0abb75f0fbd3?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fGh1c2t5JTIwcHVwcHl8ZW58MHx8MHx8fDA%3D" }
    ],
    petstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/29781558/",
        thumbnail: "https://images.unsplash.com/photo-1616567214738-22fc0c6332b3?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fHNpYmVyaWFuJTIwaHVza3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    description: "Healthy and playful Siberian Husky available for sale. Raised in a loving environment with proper vaccination and nutrition. Friendly temperament, highly intelligent, and perfect for families and children.",
    age: '1 months',
    gender: 'Female',
    bookprice: 'AED 200',
    saleprice: "AED 500.00",
  },
  {
    petid: '3',
    category: 'Dog',
    microchipid: "Dog-003",
    petname: "Bruno",
    breed: "German Shepherd",
    price: "AED 730.00",
    productimage: "https://images.unsplash.com/photo-1655986910739-daa90b28095a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8R2VybWFuJTIwU2hlcGhlcmQlMjBwdXBweXxlbnwwfHwwfHx8MA%3D%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1610624427159-f77e3152cfd7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8R2VybWFuJTIwU2hlcGhlcmQlMjBwdXBweXxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1607034145556-36a4aefc3b97?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8R2VybWFuJTIwU2hlcGhlcmQlMjBwdXBweXxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '3', image: "https://images.unsplash.com/photo-1655986909840-1dbc7e7fb405?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fEdlcm1hbiUyMFNoZXBoZXJkJTIwcHVwcHl8ZW58MHx8MHx8fDA%3D" }
    ],
    petstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/29781558/",
        thumbnail: "https://www.pexels.com/download/video/27597788/"
      },
    ],
    description: "Healthy and playful German Shepherd available for sale. Raised in a loving environment with proper vaccination and nutrition. Friendly temperament, highly intelligent, and perfect for families and children.",
    age: '3 months',
    gender: 'Male',
    bookprice: 'AED 200',
    saleprice: "AED 430.00",
  },
  {
    petid: '4',
    category: 'Dog',
    microchipid: "Dog-004",
    petname: "Max",
    breed: "Rottweiler",
    price: "AED 810.00",
    productimage: "https://images.unsplash.com/photo-1643811356771-dc2c1a53e235?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Um90dHdlaWxlciUyMHB1cHB5fGVufDB8fDB8fHww",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1598819849325-f0152d605b08?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8Um90dHdlaWxlciUyMHB1cHB5fGVufDB8fDB8fHww" },
      { id: '2', image: "https://media.istockphoto.com/id/1087244152/photo/small-rottweiler-puppy-lying-outdoors.webp?a=1&b=1&s=612x612&w=0&k=20&c=aKdHiOoPmnvJ7Ua8vDYmmrFTEoPcDsSmX5FbW8RkHI8=" },
      { id: '3', image: "https://media.istockphoto.com/id/89326655/photo/cute-puppy.webp?a=1&b=1&s=612x612&w=0&k=20&c=kUurJXXkF0VvhrwlD2a4WMbFWw4pimFltekjmpd1x-4=" }
    ],
    petstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/8323033/",
        thumbnail: "https://images.unsplash.com/photo-1699927198290-b3249ca68361?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8cm90dHdlaWxlcnxlbnwwfHwwfHx8MA%3D%3D"
      },
    ],
    description: "Confident and loyal Rottweiler with muscular build and excellent guarding instincts.",
    age: '4 months',
    gender: 'Female',
    bookprice: 'AED 200'
  },

  {
    petid: '5',
    category: 'Dog',
    microchipid: "Dog-005",
    petname: "Coco",
    breed: "Pomeranian",
    price: "AED 750.00",
    productimage: "https://images.unsplash.com/photo-1641067231565-cf6c17497b59?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fFBvbWVyYW5pYW58ZW58MHx8MHx8fDA%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1578900194624-e52cd16da379?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fFBvbWVyYW5pYW58ZW58MHx8MHx8fDA%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1728055916373-840568dfb4fa?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fFBvbWVyYW5pYW58ZW58MHx8MHx8fDA%3D" },
      { id: '3', image: "https://images.unsplash.com/photo-1690985211290-208bc862142b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8UG9tZXJhbmlhbnxlbnwwfHwwfHx8MA%3D%3D" }
    ],
    petstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/18291485/",
        thumbnail: "https://images.unsplash.com/photo-1690985211290-208bc862142b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8UG9tZXJhbmlhbnxlbnwwfHwwfHx8MA%3D%3D"
      },
    ],
    description: "Cute and fluffy Pomeranian with cheerful personality and adorable appearance.",
    age: '3 months',
    gender: 'Male',
    bookprice: 'AED 200'
  },

  {
    petid: '6',
    category: 'Dog',
    microchipid: "Dog-006",
    petname: "Leo",
    breed: "Doberman",
    price: "AED 580.00",
    productimage: "https://images.unsplash.com/photo-1669084833637-2e0571a5cb92?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fERvYmVybWFuJTIwcHVwcHl8ZW58MHx8MHx8fDA%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1675529973022-d5983e9758e6?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fERvYmVybWFuJTIwcHVwcHl8ZW58MHx8MHx8fDA%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1583929665452-fdc317b7b8b1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fERvYmVybWFuJTIwcHVwcHl8ZW58MHx8MHx8fDA%3D" },
      { id: '3', image: "https://images.unsplash.com/photo-1615137793203-7341ef16745b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fERvYmVybWFuJTIwcHVwcHl8ZW58MHx8MHx8fDA%3D" }
    ],
    petstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/7516717/",
        thumbnail: "https://images.unsplash.com/photo-1623226725351-29a2b7c31431?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8RG9iZXJtYW58ZW58MHx8MHx8fDA%3D"
      },
    ],
    description: "Elegant and fearless Doberman known for intelligence, loyalty, and protection skills.",
    age: '6 months',
    gender: 'Female',
    bookprice: 'AED 200'
  },

  {
    petid: '7',
    category: 'Dog',
    microchipid: "Dog-007",
    petname: "Bella",
    breed: "Shih Tzu",
    price: "AED 408.00",
    productimage: "https://images.unsplash.com/photo-1583511655826-05700d52f4d9?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8U2hpaCUyMFR6dXxlbnwwfHwwfHx8MA%3D%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1619736163418-0826329731fe?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fFNoaWglMjBUenV8ZW58MHx8MHx8fDA%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1636738840324-b055d2254114?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fFNoaWglMjBUenV8ZW58MHx8MHx8fDA%3D" },
      { id: '3', image: "https://images.unsplash.com/photo-1629740067905-bd3f515aa739?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fFNoaWglMjBUenV8ZW58MHx8MHx8fDA%3D" }
    ],
    petstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/31996690/",
        thumbnail: "https://images.unsplash.com/photo-1629740067905-bd3f515aa739?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fFNoaWglMjBUenV8ZW58MHx8MHx8fDA%3D"
      },
    ],
    description: "Beautiful Shih Tzu with calm temperament and soft fluffy coat perfect for indoor living.",
    age: '2 months',
    gender: 'Male',
    bookprice: 'AED 200'
  },

  {
    petid: '8',
    category: 'Dog',
    microchipid: "Dog-008",
    petname: "Simba",
    breed: "Beagle",
    price: "AED 682.00",
    productimage: "https://images.unsplash.com/photo-1647097298829-e41dd4d8f92f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8QmVhZ2xlJTIwcHVwcHl8ZW58MHx8MHx8fDA%3D",
    subimage: [
      { id: '1', image: "https://plus.unsplash.com/premium_photo-1723708857381-82e3b34187b5?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8QmVhZ2xlJTIwcHVwcHl8ZW58MHx8MHx8fDA%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1512546321483-c0468b7b8a95?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8QmVhZ2xlJTIwcHVwcHl8ZW58MHx8MHx8fDA%3D" },
      { id: '3', image: "https://images.unsplash.com/photo-1656178120664-5da96c873b86?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fEJlYWdsZSUyMHB1cHB5fGVufDB8fDB8fHww" }
    ],
    petstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/34322774/",
        thumbnail: "https://images.unsplash.com/photo-1622535078397-0c81cc7eae14?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fEJlYWdsZXxlbnwwfHwwfHx8MA%3D%3D"
      },
    ],
    description: "Curious and active Beagle with friendly nature and excellent companionship qualities.",
    age: '5 months',
    gender: 'Female',
    bookprice: 'AED 200'
  },


]

export const CatBreeds = [
  {
    petid: '1',
    category: 'Cat',
    microchipid: "Cat-001",
    petname: "Luna",
    breed: "Persian Cat",
    price: "AED 80.00",
    productimage: "https://images.unsplash.com/photo-1643301092287-f0153889840b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fFBlcnNpYW4lMjBDYXQlMjBraXR0ZW58ZW58MHx8MHx8fDA%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1645352786003-f20109d07bb7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fFBlcnNpYW4lMjBDYXQlMjBraXR0ZW58ZW58MHx8MHx8fDA%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1665851486292-4da23410c539?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8UGVyc2lhbiUyMENhdCUyMGtpdHRlbnxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '3', image: "https://images.unsplash.com/photo-1673125301348-d98f7af1ac40?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fFBlcnNpYW4lMjBDYXQlMjBraXR0ZW58ZW58MHx8MHx8fDA%3D" }
    ],
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/16285105/",
        thumbnail: "https://images.unsplash.com/photo-1673125301348-d98f7af1ac40?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fFBlcnNpYW4lMjBDYXQlMjBraXR0ZW58ZW58MHx8MHx8fDA%3D"
      },
    ],

    petstatus: true,
    description: "Fluffy and calm Persian cat with beautiful long coat and affectionate personality.",
    age: '2 months',
    gender: 'Female',
  },
  {
    petid: '2',
    category: 'Cat',
    microchipid: "Cat-002",
    petname: "Leo",
    breed: "Siamese Cat",
    price: "AED 90.00",
    productimage: "https://images.unsplash.com/photo-1572590407445-ac6252f1a5b1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8U2lhbWVzZSUyMGtpdHRlbnxlbnwwfHwwfHx8MA%3D%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1555036803-4b8b34490116?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8U2lhbWVzZSUyMGtpdHRlbnxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1612537509288-04bf207a5f9f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fFNpYW1lc2UlMjBraXR0ZW58ZW58MHx8MHx8fDA%3D" },
      { id: '3', image: "https://images.unsplash.com/photo-1585930687903-a06f37b7b0ce?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fFNpYW1lc2UlMjBraXR0ZW58ZW58MHx8MHx8fDA%3D" }
    ],
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/17029744/",
        thumbnail: "https://images.unsplash.com/photo-1585930687903-a06f37b7b0ce?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fFNpYW1lc2UlMjBraXR0ZW58ZW58MHx8MHx8fDA%3D"
      },
    ],
    petstatus: true,
    description: "Elegant Siamese cat known for intelligence, blue eyes, and social behavior.",
    age: '3 months',
    gender: 'Male',
  },
  {
    petid: '3',
    category: 'Cat',
    microchipid: "Cat-003",
    petname: "Bella",
    breed: "Maine Coon",
    price: "AED 120.00",
    productimage: "https://images.unsplash.com/photo-1445499348736-29b6cdfc03b9?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TWFpbmUlMjBDb29uJTIwa2l0dGVufGVufDB8fDB8fHww",
    subimage: [
      { id: '1', image: "https://plus.unsplash.com/premium_photo-1707353400196-06cc5a377467?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8TWFpbmUlMjBDb29uJTIwa2l0dGVufGVufDB8fDB8fHww" },
      { id: '2', image: "https://images.unsplash.com/photo-1662393556034-9a1c5c9f2712?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8TWFpbmUlMjBDb29uJTIwa2l0dGVufGVufDB8fDB8fHww" },
      { id: '3', image: "https://images.unsplash.com/photo-1689871405939-d1ea696c470c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fE1haW5lJTIwQ29vbiUyMGtpdHRlbnxlbnwwfHwwfHx8MA%3D%3D" }
    ],
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/7516652/",
        thumbnail: "https://images.unsplash.com/photo-1689871405939-d1ea696c470c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fE1haW5lJTIwQ29vbiUyMGtpdHRlbnxlbnwwfHwwfHx8MA%3D%3D"
      },
    ],
    petstatus: true,
    description: "Large and friendly Maine Coon with thick fur and playful nature.",
    age: '4 months',
    gender: 'Female',
  },
  {
    petid: '4',
    category: 'Cat',
    microchipid: "Cat-004",
    petname: "Milo",
    breed: "British Shorthair",
    price: "AED 95.00",
    productimage: "https://images.unsplash.com/photo-1599582292739-d37615cc7882?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8QnJpdGlzaCUyMFNob3J0aGFpcnxlbnwwfHwwfHx8MA%3D%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1659435092713-ce6f63684cc2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fEJyaXRpc2glMjBTaG9ydGhhaXJ8ZW58MHx8MHx8fDA%3D" },
      { id: '2', image: "https://media.istockphoto.com/id/1319774380/photo/british-cat-lying-cat-tree-scratching-post.webp?a=1&b=1&s=612x612&w=0&k=20&c=fJII3-xD9os3d9sZgTJZkfpjVXLz9gLpy_I4z4SNCfs=" },
      { id: '3', image: "https://media.istockphoto.com/id/1335374518/photo/cat-sitting.webp?a=1&b=1&s=612x612&w=0&k=20&c=pHiVFOEcO0JMG2LVQmBEFE7PWjcy6s16t2KnAFOmnUE=" }
    ],
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/36010397/",
        thumbnail: "https://media.istockphoto.com/id/1335374518/photo/cat-sitting.webp?a=1&b=1&s=612x612&w=0&k=20&c=pHiVFOEcO0JMG2LVQmBEFE7PWjcy6s16t2KnAFOmnUE="
      },
    ],
    petstatus: true,
    description: "Cute British Shorthair with dense coat and calm temperament.",
    age: '2 months',
    gender: 'Male',
  },
  {
    petid: '5',
    category: 'Cat',
    microchipid: "Cat-005",
    petname: "Kitty",
    breed: "Ragdoll",
    price: "AED 110.00",
    productimage: "https://images.unsplash.com/photo-1697358120032-c07f0d450760?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8UmFnZG9sbHxlbnwwfHwwfHx8MA%3D%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1585373683920-671438c82bfa?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8UmFnZG9sbHxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1654051605837-7e1b70dc7d1d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fFJhZ2RvbGx8ZW58MHx8MHx8fDA%3D" },
      { id: '3', image: "https://images.unsplash.com/photo-1620933288385-b2f6f1931d9e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fFJhZ2RvbGx8ZW58MHx8MHx8fDA%3D" }
    ],
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/15852458/",
        thumbnail: "https://images.unsplash.com/photo-1620933288385-b2f6f1931d9e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fFJhZ2RvbGx8ZW58MHx8MHx8fDA%3D"
      },
    ],
    petstatus: true,
    description: "Gentle Ragdoll cat with soft fur and affectionate personality.",
    age: '5 months',
    gender: 'Female',
  },
  {
    petid: '6',
    category: 'Cat',
    microchipid: "Cat-006",
    petname: "Oliver",
    breed: "Bengal Cat",
    price: "AED 130.00",
    productimage: "https://images.unsplash.com/photo-1647806422508-0322f33e270b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8QmVuZ2FsJTIwQ2F0fGVufDB8fDB8fHww",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1708863827435-931d4491050c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fEJlbmdhbCUyMENhdHxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1640249029702-7ad678dc51cd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fEJlbmdhbCUyMENhdHxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '3', image: "https://media.istockphoto.com/id/1276717883/photo/bengal-cat-at-home.webp?a=1&b=1&s=612x612&w=0&k=20&c=h2OF9D8DPUsREfhPFpdXjuAo5fagRRfmPzxSRh_s6Cw=" }
    ],
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/19414358/",
        thumbnail: "https://media.istockphoto.com/id/1276717883/photo/bengal-cat-at-home.webp?a=1&b=1&s=612x612&w=0&k=20&c=h2OF9D8DPUsREfhPFpdXjuAo5fagRRfmPzxSRh_s6Cw="
      },
    ],
    petstatus: true,
    description: "Active Bengal cat with leopard-like spots and energetic nature.",
    age: '4 months',
    gender: 'Male',
  },
  {
    petid: '7',
    category: 'Cat',
    microchipid: "Cat-007",
    petname: "Chloe",
    breed: "Scottish Fold",
    price: "AED 100.00",
    productimage: "https://images.unsplash.com/photo-1595433708220-3aa013e5e43f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8U2NvdHRpc2glMjBGb2xkfGVufDB8fDB8fHww",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1634206332775-3da1b8b3c73c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fFNjb3R0aXNoJTIwRm9sZHxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '2', image: "https://plus.unsplash.com/premium_photo-1764187752948-5dd6de55fb14?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fFNjb3R0aXNoJTIwRm9sZHxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '3', image: "https://images.unsplash.com/photo-1627373574917-572a86881d73?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8U2NvdHRpc2glMjBGb2xkfGVufDB8fDB8fHww" }
    ],
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/4147615/",
        thumbnail: "https://images.unsplash.com/photo-1627373574917-572a86881d73?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8U2NvdHRpc2glMjBGb2xkfGVufDB8fDB8fHww"
      },
    ],
    petstatus: true,
    description: "Adorable Scottish Fold with folded ears and sweet personality.",
    age: '3 months',
    gender: 'Female',
  },
  {
    petid: '9',
    category: 'Cat',
    microchipid: "Cat-009",
    petname: "Nala",
    breed: "Russian Blue",
    price: "AED 105.00",
    productimage: "https://images.unsplash.com/photo-1602268867596-b5986728e2fd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8UnVzc2lhbiUyMEJsdWV8ZW58MHx8MHx8fDA%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1602937488950-3dbc2ff03d2d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8UnVzc2lhbiUyMEJsdWV8ZW58MHx8MHx8fDA%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1639744421851-f7c0a1cab27f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8UnVzc2lhbiUyMEJsdWV8ZW58MHx8MHx8fDA%3D" },
      { id: '3', image: "https://media.istockphoto.com/id/802439934/photo/the-russian-blue-cat.webp?a=1&b=1&s=612x612&w=0&k=20&c=ykeQoVaqqedzfU0ropVp5kTvwVcFuEKdKwcuULTdcXE=" }
    ],
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/7470503/",
        thumbnail: "https://media.istockphoto.com/id/802439934/photo/the-russian-blue-cat.webp?a=1&b=1&s=612x612&w=0&k=20&c=ykeQoVaqqedzfU0ropVp5kTvwVcFuEKdKwcuULTdcXE="
      },
    ],
    petstatus: true,
    description: "Elegant Russian Blue with silky coat and gentle personality.",
    age: '2 months',
    gender: 'Female',
  },
]

export const MixBreed = [
  {
    petid: '101',
    category: 'Dog',
    microchipid: "Dog-001",
    petname: "Coco",
    breed: "Golden Retriever",
    price: "AED 70.00",
    productimage: "https://images.unsplash.com/photo-1591160690555-5debfba289f0?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Z29sZGVuJTIwcmV0cmlldmVyJTIwcHVwcHl8ZW58MHx8MHx8fDA%3D",
    subimage: [
      { id: '1', image: "https://plus.unsplash.com/premium_photo-1694819488591-a43907d1c5cc?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Z29sZGVuJTIwcmV0cmlldmVyJTIwcHVwcHl8ZW58MHx8MHx8fDA%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1625794084867-8ddd239946b1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGdvbGRlbiUyMHJldHJpZXZlciUyMHB1cHB5fGVufDB8fDB8fHww" },
      { id: '3', image: "https://images.unsplash.com/photo-1600804340584-c7db2eacf0bf?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGdvbGRlbiUyMHJldHJpZXZlciUyMHB1cHB5fGVufDB8fDB8fHww" }
    ],
    petstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/29477854/",
        thumbnail: "https://images.unsplash.com/photo-1510771463146-e89e6e86560e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGdvbGRlbiUyMHJldHJpZXZlcnxlbnwwfHwwfHx8MA%3D%3D"
      },
    ],
    description: "Healthy and playful Golden Retriever puppy available for sale. Raised in a loving environment with proper vaccination and nutrition. Friendly temperament, highly intelligent, and perfect for families and children.",
    age: '2 months',
    gender: 'Male',
    tag: "Most Active",
    pettype: 'adopt',
  },
  {
    petid: '102',
    category: 'Dog',
    microchipid: "Dog-002",
    petname: "Milo",
    breed: "Siberian Husky",
    price: "AED 70.00",
    productimage: "https://images.unsplash.com/photo-1617895153857-82fe79adfcd4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aHVza3klMjBwdXBweXxlbnwwfHwwfHx8MA%3D%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1566903451935-7e8835ed3e97?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8aHVza3klMjBwdXBweXxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1543554618-7e19c5e393d9?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fGh1c2t5JTIwcHVwcHl8ZW58MHx8MHx8fDA%3D" },
      { id: '3', image: "https://images.unsplash.com/photo-1523286435788-0abb75f0fbd3?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fGh1c2t5JTIwcHVwcHl8ZW58MHx8MHx8fDA%3D" }
    ],
    petstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/29781558/",
        thumbnail: "https://images.unsplash.com/photo-1616567214738-22fc0c6332b3?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fHNpYmVyaWFuJTIwaHVza3l8ZW58MHx8MHx8fDA%3D"
      },
    ],
    description: "Healthy and playful Siberian Husky available for sale. Raised in a loving environment with proper vaccination and nutrition. Friendly temperament, highly intelligent, and perfect for families and children.",
    age: '1 months',
    gender: 'Female',
    tag: "Blue Eyes",
    pettype: 'buy',
  },
  {
    petid: '103',
    category: 'Dog',
    microchipid: "Dog-003",
    petname: "Bruno",
    breed: "German Shepherd",
    price: "AED 70.00",
    productimage: "https://images.unsplash.com/photo-1655986910739-daa90b28095a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8R2VybWFuJTIwU2hlcGhlcmQlMjBwdXBweXxlbnwwfHwwfHx8MA%3D%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1610624427159-f77e3152cfd7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8R2VybWFuJTIwU2hlcGhlcmQlMjBwdXBweXxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1607034145556-36a4aefc3b97?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8R2VybWFuJTIwU2hlcGhlcmQlMjBwdXBweXxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '3', image: "https://images.unsplash.com/photo-1655986909840-1dbc7e7fb405?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fEdlcm1hbiUyMFNoZXBoZXJkJTIwcHVwcHl8ZW58MHx8MHx8fDA%3D" }
    ],
    petstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/29781558/",
        thumbnail: "https://www.pexels.com/download/video/27597788/"
      },
    ],
    description: "Healthy and playful German Shepherd available for sale. Raised in a loving environment with proper vaccination and nutrition. Friendly temperament, highly intelligent, and perfect for families and children.",
    age: '3 months',
    gender: 'Male',
    tag: "Loyal",
    pettype: 'adopt',
  },
  {
    petid: '104',
    category: 'Dog',
    microchipid: "Dog-004",
    petname: "Max",
    breed: "Rottweiler",
    price: "AED 110.00",
    productimage: "https://images.unsplash.com/photo-1643811356771-dc2c1a53e235?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Um90dHdlaWxlciUyMHB1cHB5fGVufDB8fDB8fHww",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1598819849325-f0152d605b08?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8Um90dHdlaWxlciUyMHB1cHB5fGVufDB8fDB8fHww" },
      { id: '2', image: "https://media.istockphoto.com/id/1087244152/photo/small-rottweiler-puppy-lying-outdoors.webp?a=1&b=1&s=612x612&w=0&k=20&c=aKdHiOoPmnvJ7Ua8vDYmmrFTEoPcDsSmX5FbW8RkHI8=" },
      { id: '3', image: "https://media.istockphoto.com/id/89326655/photo/cute-puppy.webp?a=1&b=1&s=612x612&w=0&k=20&c=kUurJXXkF0VvhrwlD2a4WMbFWw4pimFltekjmpd1x-4=" }
    ],
    petstatus: true,
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/8323033/",
        thumbnail: "https://images.unsplash.com/photo-1699927198290-b3249ca68361?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8cm90dHdlaWxlcnxlbnwwfHwwfHx8MA%3D%3D"
      },
    ],
    description: "Confident and loyal Rottweiler with muscular build and excellent guarding instincts.",
    age: '4 months',
    gender: 'Female',
    tag: "Guard Dog",
    pettype: 'buy',
  },

  {
    petid: '105',
    category: 'Cat',
    microchipid: "Cat-001",
    petname: "Luna",
    breed: "Persian Cat",
    price: "AED 80.00",
    productimage: "https://images.unsplash.com/photo-1643301092287-f0153889840b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fFBlcnNpYW4lMjBDYXQlMjBraXR0ZW58ZW58MHx8MHx8fDA%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1645352786003-f20109d07bb7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fFBlcnNpYW4lMjBDYXQlMjBraXR0ZW58ZW58MHx8MHx8fDA%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1665851486292-4da23410c539?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8UGVyc2lhbiUyMENhdCUyMGtpdHRlbnxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '3', image: "https://images.unsplash.com/photo-1673125301348-d98f7af1ac40?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fFBlcnNpYW4lMjBDYXQlMjBraXR0ZW58ZW58MHx8MHx8fDA%3D" }
    ],
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/16285105/",
        thumbnail: "https://images.unsplash.com/photo-1673125301348-d98f7af1ac40?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fFBlcnNpYW4lMjBDYXQlMjBraXR0ZW58ZW58MHx8MHx8fDA%3D"
      },
    ],
    petstatus: true,
    description: "Fluffy and calm Persian cat with beautiful long coat and affectionate personality.",
    age: '2 months',
    gender: 'Female',
    tag: "Lap Cat",
    pettype: 'adopt',
  },
  {
    petid: '106',
    category: 'Cat',
    microchipid: "Cat-002",
    petname: "Leo",
    breed: "Siamese Cat",
    price: "AED 90.00",
    productimage: "https://images.unsplash.com/photo-1572590407445-ac6252f1a5b1?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8U2lhbWVzZSUyMGtpdHRlbnxlbnwwfHwwfHx8MA%3D%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1555036803-4b8b34490116?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8U2lhbWVzZSUyMGtpdHRlbnxlbnwwfHwwfHx8MA%3D%3D" },
      { id: '2', image: "https://images.unsplash.com/photo-1612537509288-04bf207a5f9f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fFNpYW1lc2UlMjBraXR0ZW58ZW58MHx8MHx8fDA%3D" },
      { id: '3', image: "https://images.unsplash.com/photo-1585930687903-a06f37b7b0ce?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fFNpYW1lc2UlMjBraXR0ZW58ZW58MHx8MHx8fDA%3D" }
    ],
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/17029744/",
        thumbnail: "https://images.unsplash.com/photo-1585930687903-a06f37b7b0ce?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fFNpYW1lc2UlMjBraXR0ZW58ZW58MHx8MHx8fDA%3D"
      },
    ],
    petstatus: true,
    description: "Elegant Siamese cat known for intelligence, blue eyes, and social behavior.",
    age: '3 months',
    gender: 'Male',
    tag: "Smart",
    pettype: 'buy',
  },
  {
    petid: '107',
    category: 'Cat',
    microchipid: "Cat-003",
    petname: "Bella",
    breed: "Maine Coon",
    price: "AED 120.00",
    productimage: "https://images.unsplash.com/photo-1445499348736-29b6cdfc03b9?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TWFpbmUlMjBDb29uJTIwa2l0dGVufGVufDB8fDB8fHww",
    subimage: [
      { id: '1', image: "https://plus.unsplash.com/premium_photo-1707353400196-06cc5a377467?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8TWFpbmUlMjBDb29uJTIwa2l0dGVufGVufDB8fDB8fHww" },
      { id: '2', image: "https://images.unsplash.com/photo-1662393556034-9a1c5c9f2712?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8TWFpbmUlMjBDb29uJTIwa2l0dGVufGVufDB8fDB8fHww" },
      { id: '3', image: "https://images.unsplash.com/photo-1689871405939-d1ea696c470c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fE1haW5lJTIwQ29vbiUyMGtpdHRlbnxlbnwwfHwwfHx8MA%3D%3D" }
    ],
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/7516652/",
        thumbnail: "https://images.unsplash.com/photo-1689871405939-d1ea696c470c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fE1haW5lJTIwQ29vbiUyMGtpdHRlbnxlbnwwfHwwfHx8MA%3D%3D"
      },
    ],
    petstatus: true,
    description: "Large and friendly Maine Coon with thick fur and playful nature.",
    age: '4 months',
    gender: 'Female',
    tag: "Fluffy",
    pettype: 'adopt',
  },
  {
    petid: '108',
    category: 'Cat',
    microchipid: "Cat-004",
    petname: "Milo",
    breed: "British Shorthair",
    price: "AED 95.00",
    productimage: "https://images.unsplash.com/photo-1599582292739-d37615cc7882?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8QnJpdGlzaCUyMFNob3J0aGFpcnxlbnwwfHwwfHx8MA%3D%3D",
    subimage: [
      { id: '1', image: "https://images.unsplash.com/photo-1659435092713-ce6f63684cc2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fEJyaXRpc2glMjBTaG9ydGhhaXJ8ZW58MHx8MHx8fDA%3D" },
      { id: '2', image: "https://media.istockphoto.com/id/1319774380/photo/british-cat-lying-cat-tree-scratching-post.webp?a=1&b=1&s=612x612&w=0&k=20&c=fJII3-xD9os3d9sZgTJZkfpjVXLz9gLpy_I4z4SNCfs=" },
      { id: '3', image: "https://media.istockphoto.com/id/1335374518/photo/cat-sitting.webp?a=1&b=1&s=612x612&w=0&k=20&c=pHiVFOEcO0JMG2LVQmBEFE7PWjcy6s16t2KnAFOmnUE=" }
    ],
    video: [
      {
        id: '1',
        image: "https://www.pexels.com/download/video/36010397/",
        thumbnail: "https://media.istockphoto.com/id/1335374518/photo/cat-sitting.webp?a=1&b=1&s=612x612&w=0&k=20&c=pHiVFOEcO0JMG2LVQmBEFE7PWjcy6s16t2KnAFOmnUE="
      },
    ],
    petstatus: true,
    description: "Cute British Shorthair with dense coat and calm temperament.",
    age: '2 months',
    gender: 'Male',
    tag: "Calm",
    pettype: 'buy',
  },

]